import * as React from 'react';
import cx from 'classnames';
import LoadingMask from './components/LoadingMask';
import useDelayed from './hooks/useDelayed';
export function BlockLoading(props) {
    var height = getHeight(props);
    var _a = props.loading, loading = _a === void 0 ? false : _a, _b = props.delay, delay = _b === void 0 ? 0 : _b, className = props.className, children = props.children, _c = props.icon, icon = _c === void 0 ? 'youzan' : _c, iconSize = props.iconSize, iconText = props.iconText, _d = props.textPosition, textPosition = _d === void 0 ? 'bottom' : _d;
    var hasChildren = !!children;
    var delayed = useDelayed({ loading: loading, delay: delay });
    var showMask = !delayed && loading;
    if (!showMask && !hasChildren) {
        return null;
    }
    return (React.createElement("div", { className: cx('zent-loading', 'zent-loading--block', className, {
            'zent-loading--has-children': hasChildren,
        }), style: { height: height }, "data-zv": '8.4.0' },
        children,
        showMask && (React.createElement(LoadingMask, { icon: icon, size: iconSize, text: iconText, textPosition: textPosition }))));
}
function getHeight(props) {
    var hasHeightProp = props.hasOwnProperty('height');
    var children = props.children;
    if (!children && !hasHeightProp) {
        return 160;
    }
    if (children && !hasHeightProp) {
        return 'initial';
    }
    return props.height;
}
export default BlockLoading;
